import { UseRuleGroup } from "react-querybuilder";
import React from "react";
import CiroButton, { CiroButtonStyleEnum } from "../../../../shared/CiroButton";
import classNames from "classnames";

const PowersearchRuleGroupFooterElements: (
  rg: UseRuleGroup,
) => React.JSX.Element = (rg: UseRuleGroup) => {
  return (
    <div
      className={classNames(
        "flex",
        "items-center",
        "gap-2",
        "w-full",
        "flex-row-reverse",
      )}
    >
      <CiroButton
        analyticsField="Add new rule from powerfilters"
        style={CiroButtonStyleEnum.PRIMARY}
        onClick={() => {
          rg.addRule();
        }}
      >
        + Filter
      </CiroButton>
      {rg.path.length <= 1 && (
        <CiroButton
          analyticsField="Add new group from powerfilters"
          style={CiroButtonStyleEnum.PRIMARY}
          onClick={() => {
            const group = rg.schema.createRuleGroup();
            group.rules.push(rg.schema.createRule());
            rg.onGroupAdd(group, rg.path);
          }}
        >
          + Filter group
        </CiroButton>
      )}
    </div>
  );
};

export default PowersearchRuleGroupFooterElements;
